<p-table [value]="filteredVoters" [selection]="selectedVoters" (selectionChange)="selectionChangedEvent($event)" [paginator]="true" [rows]="10"
  [rowsPerPageOptions]="[10, 50, 100]" [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}"
  styleClass="p-datatable-striped">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 0.5rem; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px;">
        <div class="flex gap-10 align-items-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>#
        </div>
      </th>
      <th pSortableColumn="lastName"
        style="width: 15%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Nom <p-sortIcon field="lastName"></p-sortIcon>
      </th>
      <th pSortableColumn="firstName"
        style="width: 15%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Prénom
        <p-sortIcon field="firstName"></p-sortIcon>
      </th>
      <th pSortableColumn="college"
        style="width: 8%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Collège
        <p-sortIcon field="college"></p-sortIcon>
      </th>
      <th pSortableColumn="email"
        style="width: 20%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Email
        <p-sortIcon field="email"></p-sortIcon>
      </th>
      <th pSortableColumn="phone"
        style="width: 12%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Mobile
        <p-sortIcon field="phone"></p-sortIcon>
      </th>
      <th pSortableColumn="challenge"
        style="width: 15%; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;">
        Défi
        <p-sortIcon field="challenge"></p-sortIcon>
      </th>
      <th style="width: 1rem; border-top: #E7F4FF solid 1px; border-bottom: #E7F4FF solid 1px; padding: 10px 0 10px 0;"
      *ngIf="editionMode">
        Actions
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-voter let-rowIndex="rowIndex">
    <tr [ngClass]="{'bg-light-gray': rowIndex % 2 === 0}">
      <td class="flex align-items-center gap-10" style="padding: 5px 0 5px 0;">
        <p-tableCheckbox [value]="voter"></p-tableCheckbox>
        {{rowIndex + 1}}
      </td>
      <td class="text-center">
        <ng-container *ngIf="editingIndex === rowIndex; else displayLastName">
          <input type="text" class="pap-input" style="width: 100%; box-sizing: border-box;"
            [value]="editingVoter.lastName" (input)="editLastNameAtIndex(rowIndex, $any($event.target).value)">
        </ng-container>
        <ng-template #displayLastName>{{ voter.lastName }}</ng-template>
      </td>
      <td class="text-center">
        <ng-container *ngIf="editingIndex === rowIndex; else displayFirstName">
          <input type="text" class="pap-input" style="width: 100%; box-sizing: border-box;"
            [value]="editingVoter.firstName" (input)="editFirstNameAtIndex(rowIndex, $any($event.target).value)">
        </ng-container>
        <ng-template #displayFirstName>{{ voter.firstName }}</ng-template>
      </td>
      <td class="text-center">
        <ng-container *ngIf="editingIndex === rowIndex; else displayCollege">
          <input type="text" class="pap-input" style="width: 100%; box-sizing: border-box;"
            [value]="editingVoter.college" (input)="editCollegeAtIndex(rowIndex, $any($event.target).value)">
        </ng-container>
        <ng-template #displayCollege>{{ voter.college }}</ng-template>
      </td>
      <td class="text-center">
        <ng-container *ngIf="editingIndex === rowIndex; else displayEmail">
          <input type="text" class="pap-input" style="width: 100%; box-sizing: border-box;" [value]="editingVoter.email"
            (input)="editEmailAtIndex(rowIndex, $any($event.target).value)">
        </ng-container>
        <ng-template #displayEmail>{{ voter.email }}</ng-template>
      </td>
      <td class="text-center">
        <ng-container *ngIf="editingIndex === rowIndex; else displayPhone">
          <input type="text" class="pap-input" style="width: 100%; box-sizing: border-box;" [value]="editingVoter.phone"
            (input)="editPhoneAtIndex(rowIndex, $any($event.target).value)">
        </ng-container>
        <ng-template #displayPhone>{{ voter.phone }}</ng-template>
      </td>
      <td class="text-center">
        <ng-container *ngIf="editingIndex === rowIndex; else displayValidationCode">
          <input type="text" class="pap-input" style="width: 100%; box-sizing: border-box;"
            [value]="editingVoter.validationCode" (input)="editValidationCodeAtIndex(rowIndex, $any($event.target).value)">
        </ng-container>
        <ng-template #displayValidationCode>{{ voter.validationCode }}</ng-template>
      </td>
      <td class="text-center" *ngIf="editionMode">
        <ng-container *ngIf="editingIndex === rowIndex; else displayEditBtn">
          <div class="flex gap-5 content-center">
            <button class="bg-white pointer" style="border: none;" (click)="cancelEdit()">
              <img src="assets/close_24px.svg" alt="cancel" width="15px">
            </button>
            <button class="bg-white pointer" style="border: none;" (click)="validateEdit(rowIndex)">
              <img src="assets/valid-square-icon.svg" alt="validate" width="15px">
            </button>
          </div>
        </ng-container>
        <ng-template #displayEditBtn>
          <button class="bg-white pointer" style="border: none;" (click)="startEdit(rowIndex)">
            <img src="assets/edit-icon.svg" alt="edit" width="15px">
          </button>
        </ng-template>
      </td>
    </tr>
  </ng-template>
</p-table>